import { useRouter } from 'next/router'
import React from 'react'
import { Button, BUTTON_INTENT, BUTTON_VARIANT } from 'components/Button'
import Icon from 'components/Icon'
import { Box } from 'components/Layout'

export const BackButton: React.FC<React.PWC> = ({ children = 'Back' }) => {
  const router = useRouter()
  return (
    <Box>
      <Button
        icon={Icon.ArrowLeft}
        intent={BUTTON_INTENT.NONE}
        variant={BUTTON_VARIANT.OUTLINE}
        onClick={() => {
          router.back()
        }}
      >
        {children}
      </Button>
    </Box>
  )
}
